import { ExternalLink } from "lucide-react";
import { SubBadge } from "@/components/admin/SectionShell";
import { GuideForm } from "./GuideForm";
import { GuideInvitesPanel } from "./GuideInvitesPanel";
import { GuideRow } from "./GuideRow";

const isPublic = (g) => g.status !== "pending" && g.status !== "rejected";

export const GuidesManager = ({ guides, setGuides, handleDrop, dragCtx, approveGuide, startEditG, deleteGuide, ...rest }) => {
  const publicGuides = guides.filter(isPublic);
  return (
    <div className="bg-[#EDF7F5] border border-[#D2E8E3] rounded-3xl p-6 mb-6" data-testid="guides-manager">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div>
          <p className="font-serif text-2xl mb-1"><SubBadge /> Guides ({guides.length})</p>
          <p className="text-sm text-muted-foreground">Add, edit, delete, and reorder guides here. The public /guides page is view-only and shows each guide’s photo with their name below it.</p>
        </div>
        <a href="/guides" target="_blank" rel="noopener noreferrer" data-testid="guides-public-preview"
          className="inline-flex items-center gap-2 rounded-full border border-accent text-accent px-5 py-2.5 text-sm hover:bg-accent hover:text-white transition-colors">
          <ExternalLink size={16} /> View public Guides page
        </a>
      </div>
      <GuideForm {...rest} />
      <GuideInvitesPanel {...rest} />
      {guides.length === 0 ? (
        <p className="text-muted-foreground text-sm">No guides yet.</p>
      ) : (
        <>
          <p className="text-xs text-muted-foreground mb-3">Drag the handle to reorder how they appear on the page.</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[70vh] overflow-y-auto pr-2" data-testid="guides-admin-grid">
            {guides.map((g, i) => (
              <GuideRow
                key={g.id} g={g} index={i}
                publicIndex={publicGuides.findIndex((item) => item.id === g.id)}
                onDragStart={(from) => { dragCtx.current = { type: "g", from }; }}
                onDrop={(to) => handleDrop("g", guides, setGuides, to, "/admin/guides/reorder")}
                approveGuide={approveGuide}
                startEditG={startEditG}
                deleteGuide={deleteGuide}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
